<template>
  <div id="index">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <!-- 头部焦点图 -->
    <banner v-bind:pageTypeId="pageTypeId"></banner>
    <div class="search_tab">
      <div class="search_tab_c">
        <router-link :to="{path:'/search',query:{keyword:keyword}}"><span :class="{'side': num == 0}">全部</span>
        </router-link>
        <router-link :to="{path:'/search_course',query:{keyword:keyword}}"><span :class="{'side': num == 1}">课程</span>
        </router-link>
        <router-link :to="{path:'/search_pubilc',query:{keyword:keyword}}"><span :class="{'side': num == 2}">公开课</span>
        </router-link>
        <router-link :to="{path:'/search_selfStudy',query:{keyword:keyword}}"><span
            :class="{'side': num == 3}">自学备考</span></router-link>
      </div>
    </div>
    <div class="main">
      <div class="search_null" v-if="selfStudyNum==0">
        <img src="../../assets/courselist/search.png" alt="" class="wuImg">
        <p>没有找到匹配的结果</p>
      </div>
      <div class="search_main selfStudy_main" v-else>
        <div class="search_con">自学备考找到{{selfStudyNum}}条结果<router-link :to="{path:'/selfStudy_list',query:{nav:2}}">
            去自学备考列表页试试更精准的搜索&gt;&gt;</router-link>
        </div>
        <ul class="clearfix">
          <li v-for="item,index in selfStudy" @click="listDetails(index)">
            <dl class="clearfix">
              <dt><img :src="item.CoverImg"></dt>
              <dd>
                <h2>{{item.Title}}</h2>
                <p class="p1">摘要：{{item.Field1}}</p>
                <p class="p2">#{{item.Label.replace(/,/g," #")}}</p>
                <p class="p3"><span>{{item.BeginTime}}</span></p>
              </dd>
            </dl>
          </li>
        </ul>
        <div class="block">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="currentPage" :page-size="12" :total="total" background
            layout="total,prev, pager, next, jumper,->">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import Header from '../../components/header/Header.vue'; //公共头部
  import banner from '../../page2/banner/banner.vue'; //头部banner图
  export default {
    components: {
      // 将组件隐射为标签,登陆弹窗
      Header,
      banner
    },
    metaInfo() {
      return {
        title: '启德考培在线 - 启德考培旗下在线课堂_出国考试在线培训_考培网校',
        meta: [{
            name: "keywords",
            content: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程"
          },
          {
            name: "description",
            content: "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
          },
        ],
      };
    },
    data() {
      return {
        pageTypeId: 13, //首页banner图
        num: 3,
        listBox: [], //列表盒子
        limit: 12,
        currentPage: 1,
        courseType: 0,
        keyword: '',
        selfStudy: [],
        selfStudyNum: 0,
        total: 0, //总条数
      }
    },
    created() { //自动触发写入的函数
      let that = this
      that.keyword = that.$route.query.keyword
      // 公开课
      that.getSearch(that.currentPage, 49, that.limit, that.keyword)
    },
    methods: {
      iconShrink() {
        this.screenup = true
      },
      iconOpen() {
        this.screenup = false
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        let that = this;
        // console.log(`当前页: ${val}`);
        that.currentPage = val
        // 公开课
        that.getSearch(that.currentPage, 49, that.limit, that.keyword)
      },
      getSearch(currentPage, courseType, limit, keyword) {
        console.log("keyword", currentPage, courseType, limit, keyword)
        let that = this;
        this.$api.get('https://schoolapi.eiceducation.com.cn/api/Search?page=' + currentPage + '&limit=' + limit +
          '&ContentType=' + courseType + '&keyword=' + keyword, '',
          (res) => {
            console.log(res, 'res')
            if (res.data.code == 200) {
              if (courseType == 49) {
                that.total = res.data.count;
                that.selfStudyNum = res.data.count;
                that.selfStudy = res.data.results
              }
              console.log(that.selfStudy, "selfStudy")
            }
          })

      },
      listDetails(cur) {
        let that = this
        var targetUser = that.selfStudy[cur].Id
        let goPage = 0
        this.$http.post('https://schoolapi.eiceducation.com.cn/api/History', {
            "ContentType": 49,
            "ContentId": targetUser,
            "WatchTime": goPage
          }, {
            "headers": {
              "ContentType": "application/json",
              "token": that.tokenkey
            }
          }).then(function(result) {
            // 添加阅读量成功后跳转
            that.$router.push({
              name: "selfStudy_details",
              query: {
                KId: targetUser,
                page: that.currentPage,
                nav: 2
              }
            })
          })
          .catch(function(error) {
            // console.log(error);
          });
      },
    },
  }
</script>

<style scoped>
  .search_tab {
    padding: 18px;
    background: #FFF;
  }

  .search_tab_c {
    width: 1180px;
    margin: 0 auto;
  }

  .search_tab span {
    display: inline-block;
    min-width: 96px;
    height: 36px;
    font-size: 14px;
    line-height: 36px;
    border-radius: 18px;
    margin-right: 5px;
    color: #333333;
    text-align: center;
    cursor: pointer;
    padding: 0 20px;
    box-sizing: border-box;
    transition: all .25s ease-in;
    -moz-transition: all .25s ease-in;
    -webkit-transition: all .25s ease-in;
  }

  .search_tab span:hover {
    color: #4E5CF6;
  }


  .search_tab span.side {
    background: #F8F8F8;
    color: #4E5CF6;
  }

  .main {
    width: 100%;
    background: #FAFAFA;
    padding-top: 24px;
    padding-bottom: 78px;
  }

  .search_con {
    font-size: 16px;
    color: #333333;
    line-height: 24px;
    height: 40px;
  }

  .search_con a {
    float: right;
    color: #4E5CF6;
    font-size: 16px;
  }

  .search_main {
    width: 1180px;
    margin: 0 auto;
  }

  .selfStudy_main ul {
    padding-bottom: 60px;
  }


  .selfStudy_main ul li {
    width: 580px;
    height: 140px;
    background: #FFFFFF;
    border-radius: 8px;
    float: left;
    margin-bottom: 20px;
    margin-right: 20px;
    cursor: pointer;
    transition: all .25s ease-in;
    -moz-transition: all .25s ease-in;
    -webkit-transition: all .25s ease-in;
  }

  .selfStudy_main ul li:nth-child(2n) {
    margin-right: 0;
  }

  .selfStudy_main ul li dl {
    padding-top: 18px;
    padding-right: 12px;
  }

  .selfStudy_main ul li dl dt {
    width: 166px;
    height: 103px;
    overflow: hidden;
    float: right;
  }

  .selfStudy_main ul li dl dt img {
    width: 166px;
    height: 103px;
  }

  .selfStudy_main ul li dl dd {
    width: 364px;
    float: left;
    padding-left: 20px;
    text-align: left;
  }

  .selfStudy_main ul li dl dd h2 {
    width: 100%;
    height: 26px;
    font-size: 16px;
    line-height: 26px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #333;
    margin-bottom: 2px;
  }

  .selfStudy_main ul li dl dd .p1 {
    width: 100%;
    font-size: 12px;
    line-height: 16px;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    white-space: normal !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #333333;
    margin-bottom: 2px;
  }

  .selfStudy_main ul li dl dd .p2 {
    font-size: 14px;
    line-height: 26px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #999;
    margin-bottom: 2px;
  }

  .selfStudy_main ul li dl dd .p3 {
    color: #666;
  }

  .selfStudy_main ul li dl dd .p3 span {
    display: inline-block;
    width: 148px;
    line-height: 18px;
    font-size: 12px;
  }

  .block {
    width: 1180px;
    margin: 0 auto;
    text-align: right;
  }

  .search_null {
    width: 1180px;
    margin: 0 auto;
    text-align: center;
  }

  .search_null p {
    font-size: 12px;
    color: #333;
    line-height: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/page2/search/search_selfStudy.vue